import apiClient from './api'

export type ChannelInput = { name: string; description?: string; id?: string }
export type StatusInput = { name: string; description?: string; id?: string }

export const configService = {
  listChannels: () => apiClient.get('/config/channels').then((res) => res.data),
  addChannel: (payload: ChannelInput) => apiClient.post('/config/channels', payload).then((res) => res.data),
  listStatuses: () => apiClient.get('/config/statuses').then((res) => res.data),
  addStatus: (payload: StatusInput) => apiClient.post('/config/statuses', payload).then((res) => res.data),
  listDepositConfigs: () =>
    apiClient.get('/config/deposit-channel-configurations').then((res) => res.data),
  updateDepositConfig: (id: string, payload: any) =>
    apiClient.patch(`/config/deposit-channel-configurations/${id}`, payload).then((res) => res.data),
  listWithdrawalConfigs: () =>
    apiClient.get('/config/withdrawal-channel-configurations').then((res) => res.data),
  updateWithdrawalConfig: (id: string, payload: any) =>
    apiClient.patch(`/config/withdrawal-channel-configurations/${id}`, payload).then((res) => res.data),
}


